export const MemberActionTypes = {
  // Service Express
  DELETE_SERVICE_PHASE: 'DELETE_SERVICE_PHASE',
  SET_SERVICE_PHASES: 'SET_SERVICE_PHASES',
  SET_RO_SERVICE_PHASES: 'SET_RO_SERVICE_PHASES',
  SET_SERVICE_EXPRESS: 'SET_SERVICE_EXPRESS',
  // Reconditioning
  DELETE_RECONDITIONING_PHASE: 'DELETE_RECONDITIONING_PHASE',
  SET_RECONDITIONING_PHASES: 'SET_RECONDITIONING_PHASES',
  SET_RO_RECONDITIONING_PHASES: 'SET_RO_RECONDITIONING_PHASES',
  SET_RECONDITIONING_EXPRESS: 'SET_RECONDITIONING_EXPRESS',
  // Parts
  UPDATE_PARTS_MATRIX_ROW: 'UPDATE_PARTS_MATRIX_ROW',
  UPDATE_PARTS_MATRIX: 'UPDATE_PARTS_MATRIX',
  RECEIVE_PARTS: 'RECEIVE_PARTS',
  RECEIVE_PARTS_SOURCES: 'RECEIVE_PARTS_SOURCES',
  RECEIVE_PARTS_MATRICES: 'RECEIVE_PARTS_MATRICES',
  ADD_NEW_PARTS_SOURCE: 'ADD_NEW_PARTS_SOURCE',
  ADD_NEW_PARTS_MATRIX: 'ADD_NEW_PARTS_MATRIX',
  DELETE_PARTS_SOURCE: 'DELETE_PARTS_SOURCE',
  DELETE_PARTS_MATRIX: 'DELETE_PARTS_MATRIX',
  DELETE_PARTS_MATRIX_ROW: 'DELETE_PARTS_MATRIX_ROW',
  CREATE_PARTS_MATRIX_ROW: 'CREATE_PARTS_MATRIX_ROW',
  CLOSE_PEMODAL: 'CLOSE_PEMODAL',
  // Setting
  RECEIVE_SETTINGS: 'RECEIVE_SETTINGS',
  RECEIVE_ENVIRONMENT_SETTINGS: 'RECEIVE_ENVIRONMENT_SETTINGS',
  GET_SETTINGS: 'GET_SETTINGS',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  SETTING_LOCKOUT: 'SETTING_LOCKOUT',
  // Price
  GET_PRICE_MATRIX: 'GET_PRICE_MATRIX',
  RECEIVE_PRICE_MATRIX: 'RECEIVE_PRICE_MATRIX',
  // Customer
  GET_ROS_BY_CUSTOMER_PHONE: 'GET_ROS_BY_CUSTOMER_PHONE',
  RECEIVE_ROS_BY_CUSTOMER_PHONE: 'RECEIVE_ROS_BY_CUSTOMER_PHONE',
  SET_SELECTED_CUSTOMER: 'SET_SELECTED_CUSTOMER',
  CUSTOMER_CREATED: 'CUSTOMER_CREATED',
  // Record
  RECORD_CREATED: 'RECORD_CREATED',
  RECORD_DELETED: 'RECORD_DELETED',
  RECORD_UPDATED: 'RECORD_UPDATED',
  CREATE_RECORD: 'CREATE_RECORD',
  DELETE_RECORD: 'DELETE_RECORD',
  UPDATE_RECORD: 'UPDATE_RECORD',
  GET_RECORDS: 'GET_RECORDS',
  RECEIVE_RECORD: 'RECEIVE_RECORD',
  RECEIVE_RECORDS: 'RECEIVE_RECORDS',
  // CRUD
  CRUD_EDIT_OPEN: 'CRUD_EDIT_OPEN',
  CRUD_EDIT_CLOSE: 'CRUD_EDIT_CLOSE',
  TOGGLE_CRUD_MODAL: 'TOGGLE_CRUD_MODAL',
  // ROS
  EMPTY_ROS: 'EMPTY_ROS',
  GET_ROS: 'GET_ROS',
  GET_ROS_BY_ADIVISOR_ID: 'GET_ROS_BY_ADIVISOR_ID',
  RECEIVE_ROS_BY_ADIVISOR_ID: 'RECEIVE_ROS_BY_ADIVISOR_ID',
  RECEIVE_ROS: 'RECEIVE_ROS',
  POLL_ROS_GET: 'POLL_ROS_GET',
  POLL_ROS_CANCEL: 'POLL_ROS_CANCEL',
  POLL_ROS_RECEIVE: 'POLL_ROS_RECEIVE',
  SET_REPAIR_ORDERS: 'SET_REPAIR_ORDERS',
  // Handle Error
  HANDLE_ERROR: 'HANDLE_ERROR',
  // Videos
  GET_VIDEOS_BY_RO_ID: 'GET_VIDEOS_BY_RO_ID',
  RECEIVE_VIDEOS_BY_RO_ID: 'RECEIVE_VIDEOS_BY_RO_ID',
  // Message
  RECEIVE_MESSAGES: 'RECEIVE_MESSAGES',
  RECEIVE_CUSTOMER_MESSAGES: 'RECEIVE_CUSTOMER_MESSAGES',
  RESET_MESSAGES: 'RESET_MESSAGES',
  SET_MESSAGE_TYPE: 'SET_MESSAGE_TYPE',
  SET_CURRENT_MESSAGE_PAGE: 'SET_CURRENT_MESSAGE_PAGE',
  UPDATE_UNREAD_MESSAGE_COUNTS: 'UPDATE_UNREAD_MESSAGE_COUNTS',
  UPDATE_LATEST_MESSAGE: 'UPDATE_LATEST_MESSAGE',
  UPDATE_MESSAGES: 'UPDATE_MESSAGES',
  // Lock
  SET_IS_LOCKED_OUT: 'SET_IS_LOCKED_OUT',
  RESET_IS_LOCKED_OUT: 'RESET_IS_LOCKED_OUT',
  // Quote
  SET_QUOTE_STATUS: 'SET_QUOTE_STATUS',
  SET_QUOTE_LOG: 'SET_QUOTE_LOG',
  // Loading
  LOADING_START: 'LOADING_START',
  LOADING_END: 'LOADING_END',
  // SMS
  SET_QUICK_SMS: 'SET_QUICK_SMS',
  SET_CHAT_INPUT_VALUE: 'SET_CHAT_INPUT_VALUE',
  TOGGLE_CHAT_MODAL: 'TOGGLE_CHAT_MODAL',
  SEND_MESSAGE: 'SEND_MESSAGE',
  // Mobile
  TOGGLE_MOBILE_VALIDATION_CONFIRM_MODAL: 'TOGGLE_MOBILE_VALIDATION_CONFIRM_MODAL',
  MOBILE_PHONE_VALIDATED: 'MOBILE_PHONE_VALIDATED',
  VALIDATING_MOBILE_PHONE: 'VALIDATING_MOBILE_PHONE',
  // Print
  SET_PRINTABLE_DOC_DATA: 'SET_PRINTABLE_DOC_DATA',
  SET_SELECTED_RECIPIENT: 'SET_SELECTED_RECIPIENT',
  SET_OPEN_DASHBOARD_MODAL: 'SET_OPEN_DASHBOARD_MODAL',
  RECEIVE_UVEYE: 'RECEIVE_UVEYE',
  RECEIVE_PAYMENT: 'RECEIVE_PAYMENT',
  RECEIVE_PAYMENTS: 'RECEIVE_PAYMENTS',
  CLEAR_PAYMENTS: 'CLEAR_PAYMENTS',
  PAYMENT_FORM_LOADED: 'PAYMENT_FORM_LOADED',
  PAYMENT_FORM_ERRORED: 'PAYMENT_FORM_ERRORED',
  WAIVER_SENT: 'WAIVER_SENT',
  UPDATE_TABLE_PARAMETER: 'UPDATE_TABLE_PARAMETER',
  UPDATE_SELECTED_MPI_TEMPLATE: 'UPDATE_SELECTED_MPI_TEMPLATE',
  TOGGLE_MPI_GENERATOR: 'TOGGLE_MPI_GENERATOR',
  SUBMIT_MPI_RESULTS: 'SUBMIT_MPI_RESULTS',
  CLEAR_SELECTED_REPAIR_ORDER: 'CLEAR_SELECTED_REPAIR_ORDER',
  SET_SELECTED_ROW: 'SET_SELECTED_ROW',
  SET_APPROVED_ONLY: 'SET_APPROVED_ONLY',
  SET_SCHEDULED_MAINTENANCE: 'SET_SCHEDULED_MAINTENANCE',
  SET_BACKGROUND_COLOR: 'SET_BACKGROUND_COLOR',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  RESET_MEMBER_STATE: 'RESET_MEMBER_STATE',
  REPAIR_ORDER_CLOSED: 'REPAIR_ORDER_CLOSED',
  RESEND_WAIVER: 'RESEND_WAIVER',
  RECEIVE_THREADS: 'RECEIVE_THREADS',
  RECEIVE_VEHICLE_LISTS: 'RECEIVE_VEHICLE_LISTS',
  RECEIVE_REPAIR_ORDER_IMAGES: 'RECEIVE_REPAIR_ORDER_IMAGES',
  RECEIVE_OP_CODES: 'RECEIVE_OP_CODES',
  SET_OP_CODES_RESPONSE: 'SET_OP_CODES_RESPONSE',
  RECEIVE_MPI_TEMPLATE_BY_ID: 'RECEIVE_MPI_TEMPLATE_BY_ID',
  RECEIVE_MPI_TEMPLATES: 'RECEIVE_MPI_TEMPLATES',
  MPI_RESULTS_SUBMITTED: 'MPI_RESULTS_SUBMITTED',
  REPAIR_ORDER_IMAGE_UPDATED: 'REPAIR_ORDER_IMAGE_UPDATED',
  GET_REPAIR_ORDER_IMAGES: 'GET_REPAIR_ORDER_IMAGES',
  GET_MPI_TEMPLATE_BY_ID: 'GET_MPI_TEMPLATE_BY_ID',
  GET_MPI_TEMPLATES: 'GET_MPI_TEMPLATES',
  DISMISS_ERROR: 'DISMISS_ERROR',
  RECEIVE_REPAIR_ORDER_INTERACTIONS: 'RECEIVE_REPAIR_ORDER_INTERACTIONS',
  RO_OUTDATED: 'RO_OUTDATED',
  CLOSE_REPAIR_ORDER: 'CLOSE_REPAIR_ORDER',
  SET_FILTERS: 'SET_FILTERS',
  SET_STATE: 'SET_STATE',
} as const;
